// extracted by mini-css-extract-plugin
export default {"wrapper":"er-z","response":"fr-z","error":"gr-z","disabled":"hr-z","buttons":"ir-z","feedbackQuestionSection":"jr-z","yesNoWrapper":"kr-z"};